import React from "react";

function Navbar(props) {
    const addToFavorites = () => {
        const title = document.title;
        const url = window.location.href;

        if (window.external && ('AddFavorite' in window.external)) {
            // Para Internet Explorer
            window.external.AddFavorite(url, title);
        } else if (window.sidebar && window.sidebar.addPanel) {
            // Para Firefox antigo
            window.sidebar.addPanel(title, url, "");
        } else {
            // Para outros navegadores
            alert('Pressione ' + (navigator.userAgent.toLowerCase().indexOf('mac') !== -1 ? 'Cmd' : 'Ctrl') + ' + D para adicionar esta página aos favoritos.');
        }
    };

    return (
        <header className="top-bar">
            <div className="logo-container-navbar">
                <img src="https://qrcbr.com.br/imagens/Logo.webp" alt="Logo" className="logo" height="40px"/>
            </div>
        </header>
    );
}

export default Navbar;